import React from 'react';
import { Drawer } from 'antd';
import { Search } from '../../types';
import { summarizePipeline } from '../../pages/searches/searchPipeline';
import PipelineStepper from './PipelineStepper';
import css from './SearchProgressDrawer.module.scss';

interface SearchProgressDrawerProps {
  open: boolean;
  search: Search | null;
  onClose: () => void;
}

const SearchProgressDrawer: React.FC<SearchProgressDrawerProps> = ({ open, search, onClose }) => {
  const summary = search ? summarizePipeline(search) : null;
  const stages = search?.pipeline?.stages;

  return (
    <Drawer
      title={search?.role ?? 'Search progress'}
      placement="right"
      width="min(420px, 94vw)"
      open={open}
      onClose={onClose}
    >
      {search && <p className={css.location}>{search.location}</p>}

      {/* A recrawl finds roles; it no longer reveals them when it finishes
          (per-user daily cap, 2026-07-27). So this says what the job is doing
          and lets the cadence line carry when results actually show up —
          "refreshing your results" pointed at an event that stopped happening. */}
      {summary?.phase === 'recrawling' && (
        <div className={css.recrawlNote}>
          Checking for new roles.
          <br />
          New matches arrive once a day.
        </div>
      )}

      {summary?.phase === 'paused' && (
        <div className={css.pausedNote}>
          Paused — progress is frozen until you resume.
        </div>
      )}

      {/* First run only: set the expectation honestly instead of leaving the
          user refreshing an inbox that fills on a scale of hours. */}
      {summary?.phase === 'running' && (
        <p className={css.pendingNote}>
          First results can take a few hours — they'll be in your daily summary
          email.
        </p>
      )}

      {stages && stages.length > 0 ? (
        <PipelineStepper stages={stages} />
      ) : (
        <p className={css.empty}>Progress details aren't available yet.</p>
      )}
    </Drawer>
  );
};

export default SearchProgressDrawer;
